"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZuoraMITConsentReference = exports.getZuoraMITConsentBrandList = exports.splitZuoraCountryList = exports.zuoraCountryCode = exports.zuoraLocale = exports.zuoraSdkUrl = void 0;
const monda_1 = require("@simplisafe/monda");
const monet_1 = require("monet");
const locale_1 = require("../commercetools/locale");
/**
 * URL of the client-size Zuora SDK.
 */
exports.zuoraSdkUrl = 'https://static.zuora.com/Resources/libs/hosted/1.3.1/zuora-min.js';
/**
 * Format a Locale for compatibility with Zuora. Converts a format like 'en-US' to 'en_US'.
 *
 * @param locale The Locale to convert.
 */
const zuoraLocale = (locale) => locale.replace(/-/, '_');
exports.zuoraLocale = zuoraLocale;
/**
 * Given a locale, returns the matching ISO 3166 Alpha-3 country code.
 *
 * @param locale The Locale for which to get the country code.
 */
const zuoraCountryCode = (locale) => (0, monda_1.safePath)([locale, 'alpha3Code'], locale_1.localeInfo);
exports.zuoraCountryCode = zuoraCountryCode;
/**
 * Given a comma-delimited list of country codes, split the elements into an array.
 *
 * @param countryList Comma-delimited country codes.
 */
const splitZuoraCountryList = (countryList) => monet_1.Maybe.fromNull(countryList)
    .map((list) => list.split(','))
    .orJust(Array.of());
exports.splitZuoraCountryList = splitZuoraCountryList;
/**
 * Supported MIT Consent brands by locale.
 */
const mitConsentBrands = {
    'en-GB': [
        'AmericanExpress',
        'Mastercard',
        'Visa'
    ],
    'en-US': [
        'AmericanExpress',
        'Discover',
        'Mastercard',
        'Visa'
    ]
};
/**
 * Get the list of MIT consent brands for the given locale as a formatted string for use with Zuora.
 */
const getZuoraMITConsentBrandList = (locale) => mitConsentBrands[locale]?.join(',') ?? '';
exports.getZuoraMITConsentBrandList = getZuoraMITConsentBrandList;
const getZuoraMITConsentReference = () => 'Commerce_MIT_Consent';
exports.getZuoraMITConsentReference = getZuoraMITConsentReference;
//# sourceMappingURL=zuora.js.map